import { ButtonBase, ButtonBaseProps, styled, Typography } from '@mui/material';
import { blue } from '@mui/material/colors';
import React from 'react';

const LinkTypography = styled(Typography)(() => ({
  color: blue[500],
  textDecoration: 'underline',
}))

type Props = ButtonBaseProps & {
  text: string;
};

const TypographyButton: React.FC<Props> = ({ text, ...props }) => {
  return (
    <ButtonBase {...props}>
      <LinkTypography variant="body2">
        {text}
      </LinkTypography>
    </ButtonBase>
  )
}

export default TypographyButton;